<template>
  <div>
    <image-slide v-if="isImage" :content="content" />
    <video-slide v-if="isVideo"  :content="content"/>
    <banner-slide v-if="isBanner" :content="content" />
  </div>
</template>

<script>
  import Image from "../image/Image"
  import Banner from "../banner/Banner"
  import Video from "../video/Video"

  export default {
    props: {
      content: {
        type: Object
      }
    },
    computed: {
      isEmpty() {
        if (!this.content.type) {
          return true;
        }
      },
      isImage() {
        if (this.content.type === 'image') {
          return true;
        }
      },
      isVideo() {
        if (this.content.type === 'video') {
          return true;
        }
      },
      isBanner() {
        if (this.content.type === 'banner') {
          return true;
        }
      }
    },
    components: {
      'image-slide': Image,
      'banner-slide': Banner,
      'video-slide': Video
    }
  }
</script>  


// WEBPACK FOOTER //
// src/components/slider/Slide.vue